
export function scrollBarWidth() {
  // eslint-disable-next-line max-len
  const width =
    window.innerWidth ||
    (document.documentElement && document.documentElement.clientWidth) ||
    (document.body && document.body.clientWidth);
  return `${(width || 0) - ((document.body && document.body.offsetWidth) || 0)}px`;
}

export function updateStyle(el, val) {
  val.forEach((prop) => {
    if (el) el.style.setProperty(prop.name, prop.value);
  });
}

export function bodyToggler(isOpened) {
  const { body } = document;
  if (body) {
    if (!isOpened) {
      updateStyle(body, [
        { name: 'overflow', value: 'hidden' },
        { name: 'padding-right', value: scrollBarWidth() },
      ]);
    } else {
      updateStyle(body, [
        { name: 'overflow', value: null },
        { name: 'padding-right', value: null },
      ]);
    }
  }
}

export const parseViewportContent = (content) => {
  const entries = content.split(',').map((param) => param.trim().split('='));
  return Object.fromEntries(entries);
};

export const getViewportElement = () => document.querySelector('meta[name=viewport]');

export const decodeViewportContent = (params) =>
  Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join(', ');

export const getViewportParams = () => parseViewportContent(getViewportElement().getAttribute('content'));

export const setViewportParams = (params) => {
  const content = { ...getViewportParams(), ...params };
  getViewportElement().setAttribute('content', decodeViewportContent(content));
};
